module.exports = __webpack_public_path__ + "img/govt_advisory_template.f6dab0a4.jpg";